import { List, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import './index.less';
import IF from '@/components/IF';
import { SoilCloseIcon, SoilProfileHistoryIcon } from '@/resource/IconComponentSets';
import { transformDateToAMorPMFormat, transformDateToTimeStamp, transfromDateToLayerDetailDateFormatter, transfromDateToTargetFormat } from '@/util/commonFunction';
import { GetPropertyListResponseModel, ISoilProfileGetLayersDetailResModel, ISoilProfileGetSoilDetailResModel, ISoilProfileLayerSampleModel } from '@/util/Request/requestType';

interface IProps {
    layerDetail?: ISoilProfileGetLayersDetailResModel
    profileDetail?: ISoilProfileGetSoilDetailResModel
    selectTargetLayerCallback: (sampleId: number, layerId: number) => void
    openFromSoilSearch?: boolean
    propertySet?: GetPropertyListResponseModel[]
}

export default function LayerDetailCell(props: IProps) {
    const {
        layerDetail,
        openFromSoilSearch = false,
        propertySet
    } = props;
    const [layerSelectModalVisible, setLayerSelectModalVisible] = useState(false);
    const [selectedSample, setSelectedSample] = useState<ISoilProfileLayerSampleModel>();
    const [historycalVisible, setHistorycalVisible] = useState(false);
    const [propertyIds, setPropertyIds] = useState<number[]>([]);
    const [localSamples, setLocalSamples] = useState<ISoilProfileLayerSampleModel[]>([]);


    useEffect(() => {
        if (layerDetail) {
            const sortIdArr = layerDetail.samples.sort((preItem, afterItem) => {
                const preSampleCode = preItem.sampleCode;
                const afterSampleCode = afterItem.sampleCode;
                const preId = parseInt(preSampleCode.substring(preSampleCode.length - 5, preSampleCode.length));
                const afterId = parseInt(afterSampleCode.substring(afterSampleCode.length - 5, afterSampleCode.length));
                return afterId - preId;
            });
            if (sortIdArr?.length > 0) {
                props.selectTargetLayerCallback( sortIdArr[0].sampleId, sortIdArr[0].layerId);
            }
            setLocalSamples([...sortIdArr]);
        }

        let cachePropertyIds = [];
        if (propertySet && propertySet.length > 0) {
            cachePropertyIds = propertySet.map(item => {
                return item.id;
            });
        }
        if (cachePropertyIds.length === 0) {
            const sortLocalSamples = localSamples.sort((preItem, afItem) => {
                if (preItem.sampleDate > afItem.sampleCode) {
                    return 1;
                } else {
                    return -1;
                }
            });
            return setSelectedSample(sortLocalSamples[0]);
        }

    }, [layerDetail]);

    const handleClickTargetSample = (layer) => {
        setSelectedSample(layer);
        props.selectTargetLayerCallback(layer.sampleId ,layer.layerId);
        setLayerSelectModalVisible(false);
    };

    useEffect(() => {
        if (propertySet && propertySet.length > 0) {
            const cachePropertyIds = propertySet.map(item => {
                return item.id;
            });
            setPropertyIds(cachePropertyIds);
        }
    }, [propertySet]);

    useEffect(() => {
        let cachePropertyIds = [];
        if (propertySet && propertySet.length > 0) {
            cachePropertyIds = propertySet.map(item => {
                return item.id;
            });
        }
        const sortLocalSamples = localSamples.sort((preItem, afItem) => {
            if (preItem.sampleDate > afItem.sampleDate) {
                return -1;
            } else {
                return 1;
            }
        });
        if (cachePropertyIds.length === 0) {
            setSelectedSample(sortLocalSamples[0]);
        } else {
            let haveBeenSelectedSample = false;
            for (const item of sortLocalSamples) {
                for (const propertyItem of item.propertyValues) {
                    const includePorperty = cachePropertyIds.includes(propertyItem.propID);
                    if (includePorperty) {
                        haveBeenSelectedSample = true;
                        setSelectedSample(item);
                        break;
                    }
                }
                if (haveBeenSelectedSample) {
                    break;
                }
            }
        }
    }, [localSamples]);

    useEffect(() => {
        if (selectedSample) {
            // const sampleCode = selectedSample.sampleCode;
            const currentSampleDate = selectedSample.sampleDate;
            let isLatest = false;
            for (const item of localSamples) {
                // const sampleCode = item.sampleCode;
                const innerSample = item.sampleDate;

                // const cacheSampleNumber = parseInt(sampleCode.substring(sampleCode.length - 3, sampleCode.length));
                // console.log('cacheSampleNumber', cacheSampleNumber);
                // console.log('sampleNumber', sampleNumber);

                if (currentSampleDate < innerSample) {
                    isLatest = true;
                    break;
                } else {
                    isLatest = false;
                    break;
                }
            }
            setHistorycalVisible(isLatest);
        }
    }, [selectedSample]);

    return (
        <div className='layer-detail-container' style={{ width: 'calc(100% + 25px)' }}>
            <Modal
                width='400px'
                footer={null}
                open={layerSelectModalVisible}
                className='anaysis-hostory-selected-modal'
                onCancel={() => setLayerSelectModalVisible(false)}
                title={(
                    <div className='layer-selected-header'>
                        <SoilProfileHistoryIcon className='icon-style'/>
                        <span className='header-string'>
                            Soil Analysis History
                        </span>
                    </div>
                )}
                closeIcon={<SoilCloseIcon />}
            >
                <div className='layer-selected-container'>
                    <List
                        dataSource={localSamples}
                        className='sample-list-style'
                        renderItem={(item) => {
                            let viewButtonEnable = false;
                            if (openFromSoilSearch && propertyIds.length > 0) {
                                for (const element of item.propertyValues) {
                                    const result = propertyIds.includes(element.propID);
                                    if (result) {
                                        viewButtonEnable = true;
                                        break;
                                    }
                                }
                            }
                            let includeSearchPropertyId = false;
                            item.propertyValues.forEach((property) => {
                                const result = propertyIds.includes(property.propID);
                                if (result === true) {
                                    includeSearchPropertyId = true;
                                }
                            });
                            if (openFromSoilSearch && propertyIds.length === 0 && includeSearchPropertyId) {
                                viewButtonEnable = true;
                            }
                            if (!openFromSoilSearch) {
                                viewButtonEnable = true;
                            }
                            return (
                                <List.Item key={item.sampleId}>
                                    <div className='sample-detail-in-div' onClick={() => {
                                        if (viewButtonEnable) {
                                            handleClickTargetSample(item);
                                        }
                                    }}>
                                        <div className='left-div'>
                                            <span>{item.sampleCode}</span>
                                            <span>{transformDateToAMorPMFormat(item.sampleDate)}</span>
                                        </div>
                                        <div className='right-div'>
                                            <button className={viewButtonEnable ? 'view-button' : 'disable-view-button'}>
                                                View
                                            </button>
                                        </div>
                                    </div>
                                </List.Item>
                            );
                        }}
                    />
                </div>
            </Modal>
            <div className='soil-analysis-cell-container'>
                <div className='soil-analysis-info'>
                    <div className='soil-analysis-title-div'>
                        {
                            `${layerDetail.layer.toUpperCase()}(${(layerDetail && layerDetail.layerStartDepth) || '0'}-${(layerDetail && layerDetail.layerEndDepth) || '0'}cm)`
                        }
                    </div>
                </div>
                <div className='sample-select-div' onClick={() => setLayerSelectModalVisible(true)}>
                    <span
                        className={selectedSample ? 'soil-button-select-sample' : 'soil-button-enable-false'}
                    >
                        {`
                            ${selectedSample && selectedSample.sampleCode || ''}${selectedSample && transfromDateToTargetFormat(selectedSample.sampleDate) || 'No Records' }${historycalVisible ? '(Historical)' : ''}
                        `}
                    </span>
                    <SoilProfileHistoryIcon className='history-icon' />
                </div>
                <IF show={!!(selectedSample && selectedSample.sampleDate)}>
                    <div className='soil-analysis-info-container'>
                        <div className='first-level-div'>
                            <span>Sampling Date</span>
                            <span>{selectedSample && transfromDateToLayerDetailDateFormatter(selectedSample.sampleDate, true) || 'no value'}</span>
                        </div>
                        <div className='first-level-div'>
                            <span>Sample Taken</span>
                            <span>{selectedSample && selectedSample.takenByName || 'no value'}</span>
                        </div>
                        <div className='first-level-div'>
                            <span>Analysed by</span>
                            <span>{selectedSample && selectedSample.analysedByName || 'no value'}</span>
                        </div>
                        <div className='first-level-div'>
                            <span>Internal Sample ID</span>
                            <span>{selectedSample && selectedSample.sampleCode || 'no value'}</span>
                        </div>
                        <div className='first-level-div'>
                            <span>Eternal Sample ID</span>
                            <span>{selectedSample && selectedSample.externalSampleID || 'no value'}</span>
                        </div>
                    </div>
                </IF>
                {selectedSample && (
                    <div className='soil-analysis-info-div'>
                        <div>
                            <span className='title-span'>
                                Soil Properties
                            </span>
                        </div>
                        <div>
                            <span className='title-span'>
                                Value
                            </span>
                        </div>
                        <div>
                            <span className='title-span'>
                                Estimation Method
                            </span>
                        </div>
                    </div>
                )}
                {selectedSample && selectedSample.propertyValues.map((item) => {
                    if (propertyIds && propertyIds.length > 0 && !propertyIds.includes(item.propID) && openFromSoilSearch) {
                        return;
                    }
                    return (
                        <div className='soil-analysis-info-value-div' key={`${item.propID}${item.propMeasurementID}`}>
                            <div className='first-div'>
                                <span style={{
                                    background: item.propertyClass=='Physicalp'?'#C6E6FF':'#E7DDFC',
                                    color: item.propertyClass=='Physical'?'#005693':'#643AAA',
                                    padding:'1px 5px',
                                    borderRadius:'4px',
                                    fontSize: '14px',
                                    fontWeight: '600',
                                    marginRight: '8px',
                                    display: 'block',
                                }}>
                                    {
                                        item.propertyClass === 'Physical' ? 'PHYSICAL' : 'CHEMICAL'
                                    }
                                </span>
                                <span className='property-name-span'>{item.propertyName}</span>
                            </div>
                            <div className='second-div'>
                                <span className='property-value-span'>
                                    {item.propertyValue}
                                </span>
                                <span>
                                    {item.unitCode}
                                </span>
                            </div>
                            <div className='third-div'>
                                <span>
                                    {item.methodName}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}